/**
 * Static OOTB trigger-type metadata used by the playbook transform path.
 *
 * These maps are intentionally checked in so the plugin does not need to load
 * built-in .now.js modules at runtime just to reverse-map sys_ids.
 * This is an anti-pattern.
 */

/** Resolved variable info returned by the reverse maps. */
export type ResolvedVariable = { name: string; type: 'string' | 'boolean' | 'number' }

/** Reverse map: trigger type sys_id → PlaybookTriggerTypes identifier for generated code. */
export const TRIGGER_TYPE_SYS_ID_TO_IDENTIFIER: Record<string, string> = {
    ab6951170f1200108c87f4f0ff767e4f: 'PlaybookTriggerTypes.RecordCreate',
    b08951170f1200108c87f4f0ff767e54: 'PlaybookTriggerTypes.RecordUpdate',
    '789911170f1200108c87f4f0ff767e27': 'PlaybookTriggerTypes.RecordCreateOrUpdate',
    d249fae6ff3f12108f25ffffffffff89: 'PlaybookTriggerTypes.Scheduled',
}

/** Reverse map: trigger input variable sys_id → { name, type }. */
export const INPUT_SYS_ID_TO_FLUENT: Record<string, ResolvedVariable> = {
    a8ae38d1ff2200108c8733af793bf15c: {
        name: 'table',
        type: 'string',
    },
    '2a8a7851ff2200108c8733af793bf131': {
        name: 'condition',
        type: 'string',
    },
    '38c838790f0010108c87f4f0ff767e5a': {
        name: 'runTriggerOnExtendedTables',
        type: 'boolean',
    },
    '82be38d1ff2200108c8733af793bf1a7': {
        name: 'table',
        type: 'string',
    },
    '52ce78d1ff2200108c8733af793bf1b3': {
        name: 'condition',
        type: 'string',
    },
    ea38f4790f0010108c87f4f0ff767edb: {
        name: 'runTrigger',
        type: 'string',
    },
    fb1af07d0f0010108c87f4f0ff767e00: {
        name: 'runTriggerOnExtendedTables',
        type: 'boolean',
    },
    '506eded1a3d312104818f363041e61b1': {
        name: 'triggerOnUniqueChange',
        type: 'boolean',
    },
    '28eef8d1ff2200108c8733af793bf14a': {
        name: 'table',
        type: 'string',
    },
    '610f3cd1ff2200108c8733af793bf11d': {
        name: 'condition',
        type: 'string',
    },
    '0e12b4790f0010108c87f4f0ff767e90': {
        name: 'runTrigger',
        type: 'string',
    },
    '726a747d0f0010108c87f4f0ff767e4b': {
        name: 'runTriggerOnExtendedTables',
        type: 'boolean',
    },
    '6fc42b59a35712104818f363041e6179': {
        name: 'triggerOnUniqueChange',
        type: 'boolean',
    },
    '12d6b834ff5022108f25ffffffffff70': {
        name: 'table',
        type: 'string',
    },
    b927b074ff5022108f25ffffffffff5c: {
        name: 'condition',
        type: 'string',
    },
    ddd78be6ff7f12108f25ffffffffffb5: {
        name: 'startDateAndTime',
        type: 'string',
    },
    '65474fa6ff7f12108f25ffffffffff35': {
        name: 'recurrence',
        type: 'string',
    },
    '6d4cfa6eff3f12108f25ffffffffff0e': {
        name: 'frequency',
        type: 'number',
    },
    '963e7622ff7f12108f25ffffffffff2b': {
        name: 'daySelection',
        type: 'string',
    },
    e21ff662ff7f12108f25ffffffffffc0: {
        name: 'daysOfTheWeek',
        type: 'string',
    },
    '908efa22ff7f12108f25ffffffffff5c': {
        name: 'dayOfMonth',
        type: 'number',
    },
    '298fb2a2ff7f12108f25ffffffffff54': {
        name: 'relativeWeek',
        type: 'number',
    },
    '88fdbeeeff3f12108f25ffffffffff08': {
        name: 'relativeWeekday',
        type: 'number',
    },
    '70adf6eeff3f12108f25ffffffffffa0': {
        name: 'repeatMonth',
        type: 'number',
    },
    a64f3e62ff7f12108f25ffffffffffb2: {
        name: 'repeat',
        type: 'string',
    },
    '2bbe3262ff7f12108f25ffffffffffa8': {
        name: 'end',
        type: 'string',
    },
    '445d72eeff3f12108f25ffffffffff41': {
        name: 'endDateTime',
        type: 'string',
    },
    '3b09b4f4ff5022108f25ffffffffff88': {
        name: 'limit',
        type: 'number',
    },
    '0587c3e6ff7f12108f25ffffffffff06': {
        name: 'timeZone',
        type: 'string',
    },
}
